import React, { useState, useEffect, useCallback } from 'react';
import { getApprovalCandidates } from 'Api/apiService';
import {
    ApproverLoadingStyled,
} from './HumanEditorV2.styles';
import { SbSelect, SbSpin, SbTooltip, TooltipTriggerStyled } from 'uiCore';

const APPROVER_TOOLTIP =
    "Choose the HR Manager who will review and approve this JD. They will be notified immediately after submission.";

// Props match the call site in SbJobDetailsV2:
//   selectedApprover    — controlled value (email string | null) from page-level state
//   setSelectedApprover — page-level state setter
//   assignedApproverName — previous approver email to pre-select on load
const ApproverSelectorV2 = ({ selectedApprover, setSelectedApprover, assignedApproverName }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                const data      = await getApprovalCandidates();
                const formatted = data.map((c) => ({ value: c.value, label: c.label }));
                setOptions(formatted);

                // Pre-select previous approver if nothing is selected yet
                if (assignedApproverName && !selectedApprover) {
                    const match = formatted.find((opt) => opt.value === assignedApproverName);
                    if (match && typeof setSelectedApprover === 'function') {
                        setSelectedApprover(match.value);
                    }
                }
            } catch (err) {
                console.error('Failed to load approvers', err);
            } finally {
                setLoading(false);
            }
        };
        fetchCandidates();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = useCallback((value) => {
        if (typeof setSelectedApprover === 'function') {
            setSelectedApprover(value || null);
        }
    }, [setSelectedApprover]);

    if (loading) {
        return (
            <ApproverLoadingStyled>
                <SbSpin size="small" />
                <span>Loading approvers...</span>
            </ApproverLoadingStyled>
        );
    }

    return (
            <>
              Assign Approver
              <SbTooltip content={APPROVER_TOOLTIP}>
                <TooltipTriggerStyled>
                  <SbSelect
                      options={options}
                      value={selectedApprover || undefined}
                      onChange={handleChange}
                      placeholder="Select HR Manager..."
                      allowClear
                      placement="bottomLeft"
                      getPopupContainer={(trigger) => trigger.parentNode}
                  />
                </TooltipTriggerStyled>
              </SbTooltip>
            </>
    );
};

export default ApproverSelectorV2;
